// extracted by mini-css-extract-plugin
export var animationContainer = "_h0-0";
export var asteriskIcon = "_h0-8";
export var conversationLeftSection = "_h0-4";
export var conversationListItem = "_h0-3";
export var conversationMiddleSection = "_h0-5";
export var conversationRightSection = "_h0-6";
export var detailsContent = "_h0-1";
export var listContainer = "_h0-7";
export var modalContent = "_h0-2";